export function newsletterSubscribe({ audienceId, email }) {
  return fetch(
    `https://boltthreads.us15.list-manage.com/subscribe/post-json?u=9a4dac637261cb5a04f733ddf&id=${audienceId}&EMAIL=${email}`,
    {
      method: 'POST',
      mode: 'no-cors',
    },
  )
}
